import { useRef, useCallback } from 'react';

/**
 * Custom hook for managing blob URLs with proper cleanup
 * Follows React rules and ensures URLs are revoked when no longer needed
 */
export function useBlobUrl() {
  const blobUrlsRef = useRef<Set<string>>(new Set());

  const createBlobUrl = useCallback((data: Blob | File): string => {
    const url = URL.createObjectURL(data);
    blobUrlsRef.current.add(url);
    return url;
  }, []);

  const revokeBlobUrl = useCallback((url: string) => {
    if (blobUrlsRef.current.has(url)) {
      URL.revokeObjectURL(url);
      blobUrlsRef.current.delete(url);
    }
  }, []);

  const revokeAllBlobUrls = useCallback(() => {
    blobUrlsRef.current.forEach((url) => {
      URL.revokeObjectURL(url);
    });
    blobUrlsRef.current.clear();
  }, []);

  return {
    createBlobUrl,
    revokeBlobUrl,
    revokeAllBlobUrls
  };
}
